import React, {Component} from 'react';
import PeriodDropDown from './PeriodDropDown'
import {PanelRender} from '../Controls/PeriodPicker/ActiveRender2'
import { getRangeObj, getRangeFrom, namedRange, setRange } from '../Shared/PersistTime';

import '../../Overview/overview.css'
import './filterpanel.css'
import './period-dropdown.css';

export default class DatePanel extends Component {
  constructor(props) {
    super(props);
    const saved = getRangeObj()
    const savedRange = namedRange(getRangeFrom(saved))
    this.state = {
      dropDown: saved?.dropDown ?? props?.dropDown ?? 0,
      modalOpen: false,
    };
    //hierarchy 1. cookie=user input, 2 parameter=special cases, 3, built in defaults
    this.startTime = savedRange?.startTime ?? props?.startTime ?? new Date(Date.now() - 24*3600 * 1000)
    this.endTime = savedRange?.endTime ?? props?.endTime ?? new Date()
    if (savedRange && props?.propagateState) {
      const param = {...savedRange, dropDown: this.state.dropDown}
      props?.propagateState('date', param)
    }
      // props.propagateState('date', savedRange)
    this.getPeriod = this.getPeriod.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
    this.interval = this.interval.bind(this);
    this.onCancel = this.onCancel.bind(this)
    this.onApply = this.onApply.bind(this)
  }
  componentDidUpdate(prevProps) {  
    if (this.props?.startTime !== prevProps?.startTime || this.props?.endTime !== prevProps?.endTime) {
      // external change, such as refresh button
      this.startTime = this.props?.startTime ?? this.startTime
      this.endTime = this.props?.endTime ?? this.endTime
    }
  }
  setPeriod (start, end, item, desc) {
    this.startTime = start
    this.endTime = end
    const newValues = {startTime: start, endTime: end, dropDown: item ?? this.state.dropDown,
      desc: desc};
    setRange(newValues)
    this.setState({dropDown: item ?? this.state.dropDown})
    if (this.props.propagateState)
      this.props.propagateState ('date', newValues);
  }

  getPeriod () {
    return [this.startTime, this.endTime]
  }
  onApply(from, to) {
    this.setPeriod (from, to, 4, 'Custom')
    this.setState({modalOpen: false});
  }
  onCancel() {
    this.setState({modalOpen: false})
  }
  interval (fn_start, fn_end = null, item, item_desc) {
    if (item === 4) { // custom range
      this.setState({ modalOpen: true, dropDown: item})
      return
    }
    let period = this.getPeriod();
    if (typeof fn_start === 'function') 
      period[0] = fn_start (this.endTime);
    else if (fn_start?.getMonth)
      period[0] = fn_start

    if (typeof fn_end === 'function') 
      period[1] = fn_end(this.endTime)
    else if (fn_end?.getMonth)
      period[1] = fn_end
    this.setPeriod(period[0], period[1], item, item_desc)
  }

  render() {
    const dropDown = this.state.dropDown
    return (
      <div className="panel-dropdown">
        <div className="pcos">
        <PeriodDropDown onUpdate={this.interval} dropDown={dropDown} />
        <PanelRender show={this.state.modalOpen} close={this.onCancel} 
          from={this.startTime} to={this.endTime} save={this.onApply}/>
        </div>
      </div>
    )  
  }
}
